module.exports = __webpack_public_path__ + "static/assets/38408091f9d07dee5aaeb91ec19e8664.svg";